import React, { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { ReactComponent as Arrow1 } from '../../images/arrow-vertical.svg';
import { ReactComponent as Arrow2 } from '../../images/arrow-horizontal.svg';
import BulletList from './Bulletlist';
import { useIsMobile } from '../../util/mediaQuery';

interface CircleItem {
  key: string;
  element: ReactElement;
  isLast?: boolean;
}

interface TimeSpanSectionProps {
  titleId: string;
  list: Record<string, unknown>;
  messageId: string;
  circles: CircleItem[];
  style?: React.CSSProperties;
}

const TimeSpanSection = ({
  titleId,
  list,
  messageId,
  circles,
  style = {},
}: TimeSpanSectionProps): ReactElement => {
  const isMobile = useIsMobile();

  return (
    <div className="investoracademy-timespan-row">
      {isMobile ? (
        <>
          <div className="investoracademy-timespan-line" aria-hidden="true">
            {circles.map((circle) => {
              return (
                <div className="investoracademy-timespan-circle" key={circle.key}>
                  {circle.element}
                  {circle.isLast && <Arrow1 />}
                </div>
              );
            })}
          </div>
          <div className="investoracademy-timespan-content">
            <h3 className="opds-styles-v1-text-title-small-strong">
              <Message id={titleId} />
            </h3>
            <BulletList
              array={list}
              size="small"
              messageId={messageId}
              listStyleType="disc"
            />
          </div>
        </>
      ) : (
        <>
          <div className="investoracademy-timespan-content">
            <h3 className="opds-styles-v1-text-title-small-strong">
              <Message id={titleId} />
            </h3>
            <BulletList
              array={list}
              size="small"
              messageId={messageId}
              listStyleType="disc"
            />
          </div>
          <div className="investoracademy-timespan-line" style={style} aria-hidden="true">
            {circles.map((circle) => {
              return (
                <div className="investoracademy-timespan-circle" key={circle.key}>
                  {circle.element}
                  {circle.isLast && <Arrow2 />}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default TimeSpanSection;
